import { render } from "./Main.vue?vue&type=template&id=ae8664d2&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=ae8664d2&scoped=true&lang=css"
import "./Main.vue?vue&type=style&index=1&id=ae8664d2&lang=css"
script.render = render
script.__scopeId = "data-v-ae8664d2"

export default script